import * as React from "react";
import "./ConsentComponent.scss";
import { VIDEOCHAT_CONSENT_ACKNOWLEDGED } from "../actions";
import { connect } from "react-redux";
import { RootDispatch } from "../../types";

interface OwnProps {
  consentMessage?: string;
}

interface DispatchProps {
  dispatch: RootDispatch;
}
type Props = OwnProps & DispatchProps;

class ConsentComponent extends React.PureComponent<Props> {
  public constructor(props: Props) {
    super(props);
  }

  handleAchnowledgeClick = () => {
    this.props.dispatch({ type: VIDEOCHAT_CONSENT_ACKNOWLEDGED });
  };

  public render() {
    return (
      <div className="consent-container">
        <div className="consent">
          <div className="advisory">Telehealth Advisory</div>
          <div className="consentMessage mt-15 mb-25">{this.props.consentMessage}</div>
          <div className="flex-justify-center mb-20">
            <button onClick={this.handleAchnowledgeClick} className="highlight agree-btn">
              Acknowledge
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(ConsentComponent);
